import React from 'react';
import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';

interface Props {
  onRezept: () => void;
  onReset: () => void;
  onRezeptsInvoice: () => void;
  onLongTerm: () => void;
  onGaijiList: () => void;
  onVisitCheck: () => void;
  /**
   * 令和8年法改正 No 7 — whether the month has anything to file at all.
   *
   * A practice with no 訪問施術料4/5 gets NO button rather than a disabled one
   * (客先確定 2026-08-17, feedback No.72).
   */
  showVisitSummary?: boolean;
  onVisitSummary?: () => void;
  visitSummaryLoading?: boolean;
  onKakutei: () => void;
}

const RezeptListActionBar: React.FC<Props> = ({
  onRezept,
  onReset,
  onRezeptsInvoice,
  onLongTerm,
  onGaijiList,
  onVisitCheck,
  showVisitSummary = false,
  onVisitSummary,
  visitSummaryLoading = false,
  onKakutei,
}) => (
  <BottomBar
    variant="action"
    visible
    fixed
    left={
      <>
        <AppButton type="primary" className="rounded" onClick={onRezept}>
          <i className="mr-2 fa fa-print" aria-hidden="true" />
          レセプト発行
        </AppButton>
        <AppButton type="primary" className="rounded" onClick={onReset}>
          <i className="mr-2 fa fa-paper-plane" aria-hidden="true" />
          未印刷に戻す
        </AppButton>
        <AppButton className="rounded" onClick={onRezeptsInvoice}>
          請求患者一覧
        </AppButton>
        <AppButton className="rounded" onClick={onLongTerm}>
          月16回受診者
        </AppButton>
        <AppButton className="rounded" onClick={onGaijiList}>
          外字リスト
        </AppButton>
        <AppButton className="rounded" onClick={onVisitCheck}>
          訪問データチェック
        </AppButton>
        {/*
          Q&A No.1 (亀井 2026-07-03) pins the placement: 「訪問データチェック」等の並びに
          表示 — same row as 訪問データチェック, not the toolbar above the table. Test case
          NO07_UI_C01 checks exactly this.
        */}
        {showVisitSummary && (
          <AppButton className="rounded" onClick={onVisitSummary} loading={visitSummaryLoading}>
            訪問施術総括表
          </AppButton>
        )}
      </>
    }
    right={
      <AppButton type="primary" className="rounded" onClick={onKakutei}>
        <i className="mr-2 fa fa-paper-plane" aria-hidden="true" />
        確定
      </AppButton>
    }
  />
);

export default RezeptListActionBar;
